import React from 'react';
import { Shirt, Sparkles, Smartphone, Tv, UtensilsCrossed, Wrench, FileText, Package } from 'lucide-react';
import { services } from '../utils/mockData';

const iconMap = {
  Shirt,
  Sparkles,
  Smartphone,
  Tv,
  UtensilsCrossed,
  Wrench,
  FileText,
  Package
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#204FA7] mb-4">
            Nos Services de Transport
          </h2>
          <p className="text-lg text-gray-600">
            Nous transportons tous types de colis entre Paris et Abidjan en toute sécurité
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="group bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-[#204FA7] hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-[#204FA7]/10 to-[#1CA1CC]/10 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <IconComponent className="text-[#204FA7]" size={28} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {service.name}
                </h3>
                <p className="text-sm text-gray-600">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 bg-[#F3A530]/10 px-6 py-3 rounded-full">
            <Package className="text-[#F3A530]" size={20} />
            <span className="text-[#204FA7] font-medium">
              Et bien d'autres articles ! Contactez-nous pour plus d'informations
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
